import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  const bonuses = [{
    title: 'Entrenamiento Mental y Rendimiento en el Fútbol Juvenil',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Checklist de Resiliencia para Después del Partido',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía de Alimentación Inteligente Antes y Después de Competir',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Recetario Deportivo para Futbolistas',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Manual del Padre que Acompaña al Futbolista con Inteligencia',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1536104968055-4d61aa56f46a?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Diario de Progreso y Entrenamiento del Futbolista',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía del Vestuario: Mentalidad, Convivencia y Actitud',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Historias de Superación en el Fútbol',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía principal: Cómo Despertar el Amor por el Fútbol en tu Hijo',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  const totalValue = 118;
  return <section className="py-20 md:py-28 bg-white" data-id="element-219">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-221">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#f8f9fa] mb-6" data-id="element-222">
            <GiftIcon className="w-6 h-6 text-brand-slate" data-id="element-223" />
          </div>
          <h2 className="md:text-4xl font-heading text-brand-slate mb-4 text-[25px]" data-id="element-224">
            Además, recibirás estos
          </h2>
          <p className="text-base md:text-lg text-brand-slate-light leading-relaxed" data-id="element-225">
            Complementos diseñados para potenciar los resultados de la guía
            principal para ti y tu hijo.
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-226">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-row items-center p-4 md:p-5 bg-white rounded-2xl border border-gray-100 gap-4" data-id="element-227">
              <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden border border-gray-50" data-id="element-228">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-229" />
              </div>
              <div className="flex-grow min-w-0" data-id="element-230">
                <h4 className="text-base sm:text-lg font-medium text-brand-slate leading-tight mb-1" data-id="element-231">
                  {bonus.title}
                </h4>
                <p className="text-xs sm:text-sm text-brand-slate-muted flex items-center" data-id="element-232">
                  <CheckIcon className="w-3.5 h-3.5 text-brand-amber mr-1.5 flex-shrink-0" data-id="element-233" />
                  Incluido gratis hoy
                </p>
              </div>
              <div className="flex-shrink-0 text-right ml-2" data-id="element-234">
                <span className="text-xs text-brand-slate-muted uppercase tracking-wide font-medium block mb-0.5" data-id="element-235">
                  Valor
                </span>
                <span className="text-base sm:text-lg font-medium text-brand-slate-muted line-through" data-id="element-236">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-[#1a1a2e] text-white rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-237">
          <h3 className="text-2xl md:text-3xl font-heading mb-8 leading-tight" data-id="element-238">
            Resumen de Inversión
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-8" data-id="element-239">
            <div data-id="element-240">
              <p className="text-white/60 text-xs uppercase tracking-wide mb-2" data-id="element-241">
                Valor Total Real
              </p>
              <p className="text-3xl md:text-4xl font-medium text-white/40 line-through" data-id="element-242">
                €{totalValue}
              </p>
            </div>
            <div className="hidden md:block w-px h-12 bg-white/10" data-id="element-243"></div>
            <div data-id="element-244">
              <p className="text-brand-amber uppercase tracking-wide mb-2 text-[19px] font-[800]" data-id="element-245">
                Precio Especial HOY
              </p>
              <p className="text-4xl md:text-5xl font-heading text-white" data-id="element-246">
                €17.99
              </p>
              <p className="mt-2 max-w-xs mx-auto text-[9px] text-[#FFFFFF]" data-id="element-247">
                Al pagar, verás el precio en tu moneda local con el tipo de
                cambio correspondiente, sin impuestos adicionales.
              </p>
            </div>
          </div>

          <p className="text-white/80 text-base md:text-lg font-[700]" data-id="element-248">
            HOY todo el paquete con un 70% de descuento
          </p>
        </motion.div>
      </div>
    </section>;
}